import uuidv4 from 'uuid/v4';

import {AlarmStage} from '../alarmStage';

export const getAlarmBase = (isBB) => {
    return {
        id: uuidv4(),
        group: isBB ? 'INFECTION CONTROL' : null,
        name: '',
        stage: AlarmStage.High.color,
        description: null,
        onBanner: true,
        state: 'confirm',
        userAdd: null,
        userAddLogin: null,
        userAddId: null,
        dateAdd: null,
        expireDate: null,
        deleted: null,
        userDelete: null,
        userDeleteLogin: null,
        userDeleteId: null,
        dateDelete: null,
        acknowledgeBy: [],
    };
};